import React from "react";
import { Image, withFocusable, Tag } from "../../services/visualLibraryService";
import { withAppState } from "../../state";
import Logo from "../../components/Logo";
import { i18n } from "../../services/i18nService";
import {
  LandingPageStyled,
  BuyAssetContainer,
  FirstContainerStyle,
  LogoStyled,
  HeadingContentStyled,
  HeadingStyle,
  StepContainer,
  StepNumber,
  StepText,
  PriceStyled,
  ImageStyle,
  TextDetailsStyled,
  DetailsContainerStyle,
  TextStyled,
  QRCodeWrapper,
  ButtonModelWrapper,
  ButtonModalStyled,
  TextContainer
} from "./styles/Styled";
import { Loading } from "../../services/visualLibraryService";
import { getOneTimeAuthToken, getWebPortalURL, getTVODAssetsStatus } from "../../services/tvodService";
import { base64Encode, generateSignatureSHA512 } from "../../utils/encodingUtil";
import { config } from "../../config/config";
import QRCodeReact from "react-qr-code";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getLocaleFromLocalCache } from "../../services/localeCacheService";
import { getSdk } from "../../services/sdkService";
import { trackPage } from "../../services/analyticsService";
import FreeLogo from "../../components/FreeLogo";

const INIT = "INIT";
const PAGE = "buyAsset";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const cancelFocusPath = "buttonCancelBuyAsset";

class BuyAsset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: (this.props.location && this.props.location.state && this.props.location.state.data) || {},
      loading: false,
      QRCodeURL: ""
    };
    this.pollingFinishTime = new Date(Date.now() + 5 * 60 * 1000); // the next five minutes
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const token = await getOneTimeAuthToken();
    const locale = getLocaleFromLocalCache();

    const { contentTitle, contentId, contentOldPrice, contentNewPriceId, contentType } = this.state.data;

    trackPage.call(this, PAGE);

    const pollingIntervalTime = config.get().buyAssetOrBrand && config.get().buyAssetOrBrand.pollingTime;
    const signature = {
      assetId: contentId,
      subscriptionType: contentType,
      priceProduct: contentNewPriceId
    };
    const hashedSignature = generateSignatureSHA512(signature);
    let urlQueryParams = `assetTitle=${contentTitle}&assetId=${contentId}&subscriptionType=${contentType}&priceProduct=${contentNewPriceId}&token=${token}&signature=${hashedSignature}`;
    urlQueryParams = contentOldPrice ? `${urlQueryParams}&oldPrice=${contentOldPrice}` : urlQueryParams;
    const encodedURLPart = base64Encode(urlQueryParams);

    let qrCodeURL = `${getWebPortalURL()}/${locale}/settings/tvpayment/tvodpayment/checkout?key=${encodedURLPart}`;
    this.setState({
      QRCodeURL: qrCodeURL,
      loading: false
    });
    this.timer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > this.pollingFinishTime) {
          clearInterval(this.timer);
          await this.backUserWithUpdatedData();
        } else {
          let result = await getTVODAssetsStatus(contentId);
          if (result && result.length > 0 && result[0].status === INIT) {
            clearInterval(this.timer);
            await this.backUserWithUpdatedData();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, pollingIntervalTime);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  async onBack() {
    this.backUserWithUpdatedData();
    return true;
  }

  async backUserWithUpdatedData() {
    const { history } = this.props;
    const sdk = await getSdk();
    await sdk.mediaManager.clearLayoutCache();
    history.goBack();
  }

  render() {
    const { contentTitle, contentPrice, contentCurrency, contentImage, contentType, contentTypeShow } = this.state.data;
    const { loading } = this.state;
    const rentDisclaimerHours = config.get().rentDisclaimerTime.days;
    const rentDisclaimerMins = config.get().rentDisclaimerTime.hours;
    let assetPrice = `${contentCurrency ? contentCurrency : ""} ${contentPrice}`;
    return loading ? (
      <Loading overlay />
    ) : (
      <>
        <LogoStyled>
          <FreeLogo />
        </LogoStyled>
        <LandingPageStyled>
          <BuyAssetContainer>
            <FirstContainerStyle>
              <ImageStyle>
                <Image url={contentImage} alt="image missing" />
              </ImageStyle>
              <TextContainer>
                <TextStyled
                  rank="3"
                  text={
                    contentType === "rent"
                      ? i18n.get("pages.detail.disclaimer.rent", rentDisclaimerHours, rentDisclaimerMins)
                      : i18n.get("pages.detail.disclaimer.purchase")
                  }
                  size="small"
                />
              </TextContainer>
            </FirstContainerStyle>
            <DetailsContainerStyle>
              <Tag backColor="default" text={contentTypeShow} color="black" size="medium" />
              <HeadingStyle>
                <HeadingContentStyled rank={1} text={contentTitle} size="large" />
                <PriceStyled rank={1} text={assetPrice} size="large" />
              </HeadingStyle>
              <TextDetailsStyled
                rank="3"
                text={i18n.get(
                  "pages.buyasset.heading",
                  contentType === "rent" ? i18n.get("pages.buyasset.rent") : i18n.get("pages.buyasset.buy")
                )}
                size="small"
              />
              <>
                <StepContainer>
                  <StepNumber>1</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyasset.step1")} size="medium" />
                </StepContainer>
                <StepContainer>
                  <StepNumber>2</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyasset.step2")} size="medium" />
                </StepContainer>
                <StepContainer>
                  <StepNumber>3</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyasset.step3")} size="medium" />
                </StepContainer>
              </>
            </DetailsContainerStyle>
            <QRCodeWrapper>
              <QRCodeReact value={this.state.QRCodeURL} size={336} />
            </QRCodeWrapper>
          </BuyAssetContainer>
          <ButtonModelWrapper>
            <ButtonModalFocus
              label={i18n.get("global.cancel").toUpperCase()}
              focusPath={cancelFocusPath}
              onEnterPress={() => this.backUserWithUpdatedData()}
              size="medium"
            />
          </ButtonModelWrapper>
        </LandingPageStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(BuyAsset));
Component.defaultFocusPath = cancelFocusPath;
export default Component;
